.c6{flex-wrap:wrap;}